var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.showsChargeBtn ? _c('v-btn', _vm._b({
    staticClass: "caption point-btn",
    attrs: {
      "disabled": _vm.chargeDisabled,
      "text": "",
      "block": "",
      "tile": "",
      "color": "primary",
      "height": "54px"
    },
    on: {
      "click": _vm.charge
    }
  }, 'v-btn', {
    loading: _vm.loading
  }, false), [_vm._v("지급하기")]) : _c('v-btn', _vm._b({
    staticClass: "caption point-btn",
    attrs: {
      "text": "",
      "block": "",
      "tile": "",
      "color": "secondary",
      "height": "54px",
      "to": _vm.pointTo
    }
  }, 'v-btn', {
    loading: _vm.loading
  }, false), [_vm._v(_vm._s(_vm.pointText))]);
}
var staticRenderFns = []

export { render, staticRenderFns }